let createHistory;
if (process.env.NODE_ENV !== 'production') {
  createHistory = require('history').createHashHistory;
} else {
  createHistory = require('history').createMemoryHistory;
}
export default createHistory();
